let _ = require('../_.js');
let $ = jQuery;

_.Wishlist = class Wishlist {

    static saved_property_ids = [];
    static is_loading = false;

    static async init() {
        // INCOMPLETE.
        // _.on_ui_update_always(function () {
        $(".wishlist-button").hide();
        // });

        return;

        // Load saved items from server if logged in
        if (_.ac_state.registrant) {
            await _.Wishlist.load_saved_properties();
        }

        // Initialize wishlist buttons
        _.Wishlist.update_buttons();

        // Handle click on wishlist buttons
        _.on_ui_update_once(".wishlist-button", function () {
            $(this).click(async function (e) {
                e.preventDefault();

                const $button = $(this);
                const propertyId = $button.data('property-id');
                const itemType = $button.data('type'); // 'auction' or 'listing'

                // Check if user is logged in
                if (!_.ac_state.registrant) {
                    // Show login modal
                    _.AuctionUI_Login.login_modal();
                    return;
                }

                // Disable button while processing
                $button.prop('disabled', true);

                // Toggle wishlist status
                await _.Wishlist.toggle_property(propertyId, itemType);

                // Re-enable button
                $button.prop('disabled', false);
            });
        });
    }

    static async load_saved_properties() {
        // INCOMPLETE.
        return;

        if (_.Wishlist.is_loading) return;

        _.Wishlist.is_loading = true;
        try {
            const response = await _.backend_ajax('saved_properties', 'ids');
            if (response && response.property_ids) {
                _.Wishlist.saved_property_ids = response.property_ids;
                _.Wishlist.update_buttons();
            }
        } catch (error) {
            console.error('Error loading saved properties:', error);
        } finally {
            _.Wishlist.is_loading = false;
        }
    }

    static async toggle_property(propertyId, itemType) {
        // INCOMPLETE.
        return;

        const isSaved = _.Wishlist.saved_property_ids.includes(propertyId);

        try {
            if (isSaved) {
                // Remove from saved
                const response = await _.backend_ajax('saved_properties', 'remove', {
                    property_id: propertyId
                });

                if (response && response.success) {
                    _.Wishlist.saved_property_ids = _.Wishlist.saved_property_ids.filter(id => id !== propertyId);
                    _.Flash.success(`Removed from your ${itemType}s`);
                }
            } else {
                // Add to saved
                const response = await _.backend_ajax('saved_properties', 'add', {
                    property_id: propertyId,
                    type: itemType
                });

                if (response && response.success) {
                    _.Wishlist.saved_property_ids.push(propertyId);
                    _.Flash.success(`Added to your ${itemType}s`);
                }
            }

            _.Wishlist.update_buttons();
        } catch (error) {
            console.error('Error toggling property:', error);
            _.Flash.error('Error updating your saved items');
        }
    }

    static update_buttons() {
        // INCOMPLETE.
        return;

        // Update all wishlist buttons based on property ID
        $(".wishlist-button").each(function () {
            const $button = $(this);
            const propertyId = $button.data('property-id');
            const itemType = $button.data('type');
            const isSaved = _.Wishlist.saved_property_ids.includes(propertyId);

            $button.toggleClass('wishlist-active', isSaved);
            $button.find('.button-text').text(isSaved ? `Remove from My ${itemType}s` : `Add to My ${itemType}s`);
            $button.find('i').toggleClass('fa-heart', isSaved).toggleClass('fa-heart-o', !isSaved);
        });
    }
};
